export default [
  {
    id: 1457690400,
    name: 'Temperature',
    thumb: 'assets/images/ico-waterLevel.png',
  }, {
    id: 1457690401,
    name: 'Spatial Depth',
    thumb: 'assets/images/ico-2.png',
  },
  {
    id: 1457690402,
    name: 'Humidity',
    thumb: 'assets/images/ico-3.png',
  }, {
    id: 1457690403,
    name: 'Power Leakage',
    thumb: 'assets/images/ico-4.png',

  }, {
    id: 1457690404,
    name: 'Gas Leakage',
    thumb: 'assets/images/fire.png',
  }, {
    id: 1457690405,
    name: 'Battery Charge',
    thumb: 'assets/images/ico-5.png',

  },
];



// WEBPACK FOOTER //
// ./app/routes/components/routes/AdminPanel/data/heartbeatList.js